import { render, staticRenderFns } from "./DragSlider.vue?vue&type=template&id=46e4935b&scoped=true"
import script from "./DragSlider.vue?vue&type=script&lang=js"
export * from "./DragSlider.vue?vue&type=script&lang=js"
import style0 from "./DragSlider.vue?vue&type=style&index=0&id=46e4935b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e4935b",
  null
  
)

export default component.exports